<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>供应商：</p>
        <el-input v-model="condition.supplier" size="mini" style="width:150px" placeholder="请输入供应商名称"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>车牌号：</p>
        <el-input v-model="condition.plate" size="mini" style="width:150px" placeholder="请输入车牌号"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>审核状态：</p>
        <el-select v-model="condition.audit" size="mini" filterable style="width:150px" placeholder="请选择">
          <el-option v-for="item in auditOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" type="index" align="center" width="50px"/>
          <el-table-column prop="fleetName" label="所属供应商" align="center"/>
          <el-table-column prop="license" label="车牌号" align="center"/>
          <el-table-column prop="colour" label="车牌号颜色" align="center">
            <template slot-scope="scope">{{colorFormat(scope.row.colour)}}</template>
          </el-table-column>
          <el-table-column prop="checkMax" label="最大托运数量" align="center"/>
          <el-table-column prop="operationType" label="类型" align="center" width="120">
            <div slot-scope="scope">{{scope.row.operationType==0?'新增':'变更'}}</div>
          </el-table-column>
          <el-table-column prop="examine" label="审核状态" align="center" width="120">
            <div slot-scope="scope">{{getAudit(scope.row.examine)}}</div>
          </el-table-column>
          <el-table-column label="操作" width="205" align="center">
            <template slot-scope="scope">
              <div style="align-items:center;padding-left: 10px">
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row,scope.row.operationPower)">详情</el-button>
                <el-button v-if="scope.row.examine===1&&scope.row.operationPower==1" size="mini" type="primary" @click="enableClick(scope.row)">同意</el-button>
                <el-button v-if="scope.row.examine===1&&scope.row.operationPower==1" size="mini" type="danger" @click="disableClick(scope.row)">拒绝</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width='650px' center top="8vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">所属供应商：</span>
              <span>{{detailData.fleetName}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">车牌号：</span>
              <span>{{detailData.license}}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">品牌：</span>
                <span>{{detailData.brand}}</span>
              </div>
              <div>
                <span class="span1">型号：</span>
                <span>{{detailData.model}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">发动机号：</span>
                <span>{{detailData.engine}}</span>
              </div>
              <div>
                <span class="span1">档位：</span>
                <span>{{detailData.gear}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">前后轴继承：</span>
                <span>{{detailData.loadAround}}</span>
              </div>
              <div>
                <span class="span1">整车尺寸：</span>
                <span>{{detailData.sizeLong}}*{{detailData.sizeWidth }}*{{detailData.sizeHeight }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">最大承载：</span>
                <span>{{detailData.loadMax}}</span>
              </div>
              <div>
                <span class="span1">最大托运数量：</span>
                <span>{{detailData.checkMax}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">绑定司机：</span>
              <span>{{detailData.driverName}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">照片：</span>
              <div class="imgContainer">
                <el-image
                  v-for="(item,index) in detailData.img"
                  :key="index"
                  style="width: 100px; height: 100px;margin-right:10px; "
                  :src="baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token"
                  :preview-src-list="[baseImgUrl + 'web/attachmentFtp/download?attachmentId='+(item)+'&access_token='+token]"
                  fit="cover"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>审核信息</span>
          </div>
          <steps :step-data="stepData" :step-state="stepState"/>
        </div>
        <div class="baseInfo" v-if="detailData.operationPower===1 && detailData.examine===1">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>操作</span>
          </div>
          <div class="baseInfoContentItem">
            <div style="display: flex;margin:10px 20px 0 15px;">
              <span class="span1" style="width: 70px;"><span style="color:red">*</span>原因：</span>
              <el-input
                type="textarea"
                :style="'width:100%'"
                v-model="remark"
                placeholder="请填写同意/拒绝原因"
                autocomplete="off"
                size="small"
              />
            </div>
          </div>
        </div>
        <div style="display: flex;align-items: center;justify-content: center" v-if="detailData.operationPower==1&&detailData.examine==1">
          <el-button size="medium" :loading="btnLoad.agree" type="primary" @click="agreeClick">同意</el-button>
          <el-button size="medium" :loading="btnLoad.reject" type="danger" @click="refusedClick">拒绝</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="reasonTitle" :visible.sync="reasonVisible" width='550px' center :close-on-click-modal="false" top="30vh">
      <div class="reasonContainer">
        <div style="display: flex;padding-bottom: 20px;">
          <span class="span1" style="width: 70px;"><span style="color:red">*</span>原因：</span>
          <el-input
            type="textarea"
            style="width:100%;"
            v-model="reason"
            placeholder="请填写同意/拒绝原因"
            autocomplete="off"
            size="small"
          />
        </div>
        <div class="reasonBtn">
          <el-button size="medium" :loading="btnLoad.all" class="searchBtn" type="primary" @click="reasonClick">确认</el-button>
          <el-button size="medium" class="resetBtn" type="danger" @click="reasonVisible=false">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog center title="附件详情" :visible.sync="imgDialogVisible" width="200px;" append-to-body>
      <img style="width:100%;object-fit:cover" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import steps from "@/components/steps";
import {
  transporterPageList,
  transporterDetail,
  transporterReviewSubmit,
} from "@/service/audit"
import {baseImgUrl} from "@/config/env";
import {getSessionStore} from "@/config/mUtils";
export default {
  components: {
    steps,
  },
  data() {
    return {
      // 查询条件
      condition: {
        supplier: '',
        plate: '',
        audit: '',
      },
      page:1,
      size:10,
      total:0,
      // 审核状态
      auditOption:[
        {value:'',label:'全部',},
        {value:1,label:'待审核'},
        {value:2,label:'已通过'},
      ],
      // 表格数据
      tableLoad:false,
      TableDatas:[],
      // 详情数据
      detailDialogVisible:false,
      detailData:{},
      // 详情 同意/拒绝 数据id
      activeId:'',
      // 详情 同意/拒绝 原因
      remark:'',

      // 同意/拒绝 弹窗
      reasonVisible:false,
      reasonTitle:'',
      btnLoad:{all: false, agree: false, reject: false},
      // 同意/拒绝  原因
      reason:'',

      // 审核信息
      stepData:[
        {title:'张三发起',time:'2021-9-30 14:09:23',state:'',remark:''},
        {title:'财务部 张三通过',time:'2021-9-30 14:09:23',state:'success',remark:'原因xxxxxx'},
        {title:'技术部 李四拒绝',time:'2021-9-30 14:09:23',state:'failure',remark:'原因xxxxxx'},
        {title:'张三重新发起',time:'2021-9-30 14:09:23',state:'',remark:''},
      ],

      // 附件查看弹窗
      imgDialogVisible:false,
      dialogImageUrl:'',
      baseImgUrl: baseImgUrl+ '/',
      
      token:getSessionStore('token'),
    };
  },
  computed:{
    // 详情 —— 审核信息
    stepState(){
      return function(state){
        switch(state) {
          case '':
            return 'wait'
          case 'success':
            return 'success'
          case 'failure':
            return 'error'
        }
      };
    },
    // 车牌号颜色
    colorFormat(){
      return function(value){
        switch(value) {
          case 1:
            return '蓝色'
          case 2:
            return '黄色'
          case 3:
            return '黑色'
          case 4:
            return '白色'
          case 5:
            return '其他'
        }
      };
    },
    // 审核状态
    getAudit(){
      return function(state){
        switch(state) {
          case 1:
            return '待审核'
          case 2:
            return '已通过'
          case 3:
            return '已拒绝'
        }
      };
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化
    async init(){
      await this._transporterPageList();
    },
    // 分页查询
    async _transporterPageList(){
      this.tableLoad=true;
      const res = await transporterPageList(
        {
          fleetName: this.condition.supplier,   // 所属供应商
          license: this.condition.plate,   // 车牌号
          examine: this.condition.audit,    // 审核状态
          page: this.page,
          rows: this.size,
        }
      );
      this.tableLoad = false;
      if(res.status !== 0) this.$message.error(res.message);
      this.TableDatas = res.data?res.data.records:[];
      this.total = res.data?res.data.total:0;
    },
    // 改变每页数据量
    contractSizeChange(sizes){
      this.size=sizes;
      this._transporterPageList();
    },
    // 改变当前页
    contractCurrentChange(page){
      this.page=page;
      this._transporterPageList();
    },
    // 查询
    searchBtn(){
      this.page = 1;
      this._transporterPageList();
    },
    // 重置
    resetBtn(){
      for(let key in this.condition){
        this.condition[key] = '';
      }
    },
    // 拒绝
    disableClick(row){
      this.$confirm('确认拒绝当前运输车申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.activeId = {id:row.id,operationPower:row.operationPower};
        this.reason='';
        this.reasonTitle='拒绝原因';
        this.reasonVisible=true;
      }).catch(() => {});
    },
    // 同意
    enableClick(row){
      this.$confirm('确认同意当前运输车申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.activeId = {id:row.id,operationPower:row.operationPower};
        this.reason='';
        this.reasonTitle='同意原因';
        this.reasonVisible=true;
      }).catch(() => {});
    },
    // 同意/拒绝 —— 确认
    async reasonClick(){
      this.reason=this.reason.trim();
      if(!this.reason) return this.$message.warning(this.reasonTitle==='同意原因'?'请填写同意原因！':'请填写拒绝原因!');
      this.btnLoad.all = true;
      const res = await transporterReviewSubmit({
        id:this.activeId.id,
        operationType:this.activeId.operationPower,
        auditOpinion:this.reason,
        reviewResult:this.reasonTitle==='同意原因'?'AGREE':'REFUSE',
      })
      this.btnLoad.all = false;
      if(res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      this.reasonVisible=false;
      await this._transporterPageList();
    },
    /**
     * 详情
     * @param row
     * @param operationPower 权限
     * @returns {Promise<void>}
     */
    async detailClick(row,operationPower){
      this.remark='';
      this.activeId = {id:row.id,operationPower:row.operationPower};
      this.detailDialogVisible=true
      const res = await transporterDetail(row.id);
      if(res.status !== 0) this.$message.error(res.message);
      this.detailData= {
        ...res.data,
        img:res.data.carUrl01.split(","),
        operationPower:operationPower
      }
      this.stepData = [];
      if(res.data.auditRecordList&&res.data.auditRecordList.length > 0) {
        res.data.auditRecordList.forEach((item) => {
          let status = '', temp = {}, text = '取消审核';
          if(item.status == 1) {text = '发起';}
          if(item.status == 0) {text = '重新提交';}
          if(item.status == 3) {
            status = 'failure', text = '拒绝';
            temp = {'title':item.deptName+' '+item.auditorName+' '+text,'time':item.createTime,'state':status,'remark':item.opinion}
          }
          else if(item.status == 2) {
            status = 'success', text = '同意';
            temp = {'title':item.deptName+' '+item.auditorName+' '+text,'time':item.createTime,'state':status,'remark':item.opinion}
          }
          else {
            temp = {'title':item.auditorName+' '+text,'time':item.createTime,'state':status,'remark': ''}
          }
          this.stepData.push(temp);
        })
      }
    },
    // 详情 —— 同意
    async agreeClick(){
      this.remark=this.remark.trim();
      if(!this.remark) return this.$message.warning('请填写同意理由！');
      this.btnLoad.agree = true;
      const res = await transporterReviewSubmit({
        id:this.activeId.id,
        operationType:this.activeId.operationPower,
        auditOpinion:this.remark,
        reviewResult:'AGREE',
      })
      this.btnLoad.agree = false;
      if(res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      this.detailDialogVisible=false;
      await this._transporterPageList();
    },
    // 详情 —— 拒绝
    async refusedClick() {
      this.remark = this.remark.trim();
      if (!this.remark) return this.$message.warning('请填写拒绝理由！');
      this.btnLoad.reject = true;
      const res = await transporterReviewSubmit({
        id:this.activeId.id,
        operationType:this.activeId.operationPower,
        auditOpinion: this.remark,
        reviewResult: 'REFUSE',
      })
      this.btnLoad.reject = false;
      if (res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      this.detailDialogVisible = false;
      await this._transporterPageList();
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  background-color: #fff;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .navContainer p {
      display: inline-block;
      width: 70px;
      text-align: right;
    }
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-badge__content{
          top: 4px !important;
          right: 1px !important;
        }
        .el-badge__content{
          background-color: #F56C6C !important;
        }
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height:80vh;
    overflow: auto;
    .baseInfo{
      display: flex;
      flex-direction: column;
      .attachment{
        display: flex;
        flex-direction: column;
        padding-top: 10px;
        &Item{
          width:80%;
          margin-bottom: 10px;
          margin-left:30px;
          display: flex;
          align-items: center;
          justify-content:space-between;
          span{
            color: #969696;
            font-size:14px;
          }
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  .reasonContainer{
    width:100%;
    padding: 20px 30px;
    ::v-deep{
      .el-textarea__inner{
        min-height: 100px!important;
      }
    }
    .reasonBtn{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content:flex-end;
    }
  }
  .company{
    width:100%;
    padding: 20px 10px;
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-input__inner{
        border: none;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    hr{
      margin: 0;
      position: absolute;
      width: 100%;
      bottom: 5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
